const MinusIcon = ({ className = "", size = 24, color = "#1C2A46" }) => {
  return (
    <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 0.5H12.75C12.8839 0.5 13 0.616142 13 0.75C13 0.883858 12.8839 1 12.75 1H0.75C0.616142 1 0.5 0.883858 0.5 0.75C0.5 0.616142 0.616142 0.5 0.75 0.5Z" fill="#1C2A46" stroke="#1C2A46"/>
</svg>

  );
};

export default MinusIcon;